import styled from 'styled-components';

import { Icon } from '../../primitives';
import { classnames } from '../../utilities';

import styles from './ApplicationTile.module.scss';

import { IApplication } from './types';
import { Avatar, Box, Grid2, Paper, Typography } from '@mui/material';

type IApplicationTile = {
  application: IApplication;
  isActive?: boolean;
  isDisabled?: boolean;
  onNavigate: (path: string) => void;
};

export const ApplicationIcon = styled(Icon)`
  .small & {
    font-size: 32px;
  }

  .big & {
    font-size: 48px;
  }
`;


export const ApplicationTile = ({
  application,
  isActive = false,
  isDisabled = false,
  onNavigate = (path: string) => null,
}: IApplicationTile) => {
  const combinedClassnames = classnames(
    styles['game-button'],
    isActive && styles[`active`],
    isDisabled && styles[`disabled`],
  );

  const { color, icon: Icon, name, basePath, id } = application

  return (
    <Box
      className={combinedClassnames} onClick={() => onNavigate(application.basePath)}
      width={{
        xs: '100%',
        sm: "calc(50% - 8px)"
      }}
      sx={{
        p: "8px 0",
        cursor: 'pointer',
        textAlign: 'center',
        backgroundColor: isActive ? color : 'white',
        color: isActive ? 'white' : 'text.primary',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          backgroundColor: isActive ? color : '#f8fafc',
          transform: 'translateY(-2px)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        },
      }}
    >
      <Avatar
        sx={{
          backgroundColor: isActive ? 'rgba(255,255,255,0.2)' : `${color}20`,
          color: isActive ? 'white' : color,
          mx: 'auto',
          mb: 1,
        }}
      >
        <Icon sx={{ fontSize: '1.25rem' }} />
      </Avatar>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          fontSize: '0.8rem',
          lineHeight: 1.2,
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};
